import {Dialog, DialogContentRight} from '../../ui-components/Modal';
import {Button} from '../../ui-components/Button/button';
import {ReactComponent as FolderIcon} from 'src/assets/icons/folder.svg';
import * as React from 'react';
import {useEffect, useState} from 'react';
import {StorageSource} from '../../api/types/organization/StorageSource';
import {get} from '../../utils/requests';
import {SWFT_DIGITAL_API_HOST} from '../../constants';

interface FileMovementProps {
    open: boolean;
    onClose: () => void;
    confirmMove: (folderName: string) => void;
    folderName?: string;
    orgId: string;
}

export default function FileMovement({open, onClose, confirmMove, folderName, orgId}: FileMovementProps) {
    const [folderList, setFolderList] = useState<StorageSource[]>([]);
    const [selectedFolder, setSelectedFolder] = useState<string | null>(null);

    const resetSelectionOnClose = () => {
        setSelectedFolder(null);
        onClose();
    };

    useEffect(() => {
        get(SWFT_DIGITAL_API_HOST + `/api/organization/${orgId}/storage_sources`).then((res) => {
            setFolderList(res.filter((folder: StorageSource) => folder.type === 4));
        });
    }, [open]);

    const handleFolderClick = (name: string) => {
        setSelectedFolder(name === selectedFolder ? null : name);
    };

    return (
        <Dialog open={open}>
            <DialogContentRight className='w-[411px]' onClose={resetSelectionOnClose}>
                <div className='flex flex-col justify-between'>
                    <div className='flex flex-col'>
                        <span className='text-[18px] font-[700] text-black'>Move to</span>
                        <div className='mt-6 flex flex-col justify-between gap-5 pl-2 font-[400]'>
                            {folderList &&
                                folderList
                                    .filter((folder) => !folderName || folder.name !== folderName)
                                    .map((folder) => (
                                        <div
                                            key={folder.name}
                                            className={`flex cursor-pointer items-center justify-between ${
                                                selectedFolder === folder.name
                                                    ? 'rounded-[9px] bg-[#EFF8FF] p-[8px]'
                                                    : 'rounded-[9px] bg-transparent p-[8px]'
                                            }`}
                                            onClick={() => handleFolderClick(folder.name)}>
                                            <div key={folder.name} className='flex gap-6'>
                                                <FolderIcon className={'h-6 w-6 text-gray-800'} />
                                                <span key={folder.name}>{folder.name}</span>
                                            </div>
                                        </div>
                                    ))}
                        </div>
                    </div>
                    {selectedFolder && (
                        <div className='mb-12 grid grid-cols-2 gap-2'>
                            <Button variant='secondary' size='lg' className='w-full' onClick={resetSelectionOnClose}>
                                Cancel
                            </Button>
                            <Button
                                size='lg'
                                className='w-full'
                                onClick={() => {
                                    resetSelectionOnClose();
                                    confirmMove(selectedFolder);
                                }}>
                                Move Here
                            </Button>
                        </div>
                    )}
                </div>
            </DialogContentRight>
        </Dialog>
    );
}
